import React, { useState } from "react";
import {
  EuiFieldSearch,
  EuiPopover,
  EuiButton,
  EuiContextMenu,
  EuiTabs,
  EuiTab,
  EuiCopy,
  EuiButtonEmpty,
} from "@elastic/eui";
import BauhausService from "../services/bauhaus-service";

const BauhausAdhoc = ({
  surveyFilter,
  onSurveyFilterChange,
  startDate,
  endDate,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const calls_by_events = () => {
    const token = sessionStorage.getItem("krakenT");

    BauhausService.calls_by_events({
      token,
      initDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    })
      .then((response) => {
        console.log(response.data);
        const blob = new Blob([response.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Bauhaus_Calls_By_Events.csv");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        console.error("Error downloading CSV", error);
      });
  };

  const agent_sessions_to_csv = () => {
    const token = sessionStorage.getItem("krakenT");

    BauhausService.agent_sessions({
      token,
      initDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    })
      .then((response) => {
        console.log(response.data);
        const blob = new Blob([response.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Bauhaus_Agent_Sessions.csv");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        console.error("Error downloading CSV", error);
      });
  };

  const export_008q_to_csv = async () => {
  try {
    const token = sessionStorage.getItem("krakenT");
    const company = localStorage.getItem("CN"); // si quieres filtrar por company

    const response = await BauhausService.export_008q_csv({
      token,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      company, // opcional, puedes quitarlo
    });

    const blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `Bauhaus_008Q_Evaluations_${startDate.toISOString()}_${endDate.toISOString()}.csv`
    );
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (e) {
    console.error("Error exportando CSV 008Q:", e);
  }
};


  const onButtonClick = () => {
    setIsPopoverOpen(!isPopoverOpen);
  };

  const closePopover = () => {
    setIsPopoverOpen(false);
  };

  const items = [
    {
      name: "Agent Sessions",
      icon: "download",
      onClick: () => {
        agent_sessions_to_csv();
        closePopover();
      },
    },
    {
      name: "Calls By Events",
      icon: "download",
      onClick: () => {
        calls_by_events();
        closePopover();
      },
    },
    {
  name: "008Q Evaluations (CSV)",
  icon: "download",
  onClick: () => {
    export_008q_to_csv();
    closePopover();
  },
}
    // Puedes añadir más items aquí si es necesario
  ];

  return (
    <div style={{ display: "flex", gap: 10 }}>
      <EuiFieldSearch
        title="Survey"
        style={{
          width: 500,
        }}
        placeholder="Search survey results (e.g., '< 4')"
        value={surveyFilter}
        onChange={onSurveyFilterChange}
        isClearable={true}
        aria-label="Filter survey results"
      />
      <EuiPopover
        button={
          <EuiButton
            iconType="arrowDown"
            iconSide="right"
            onClick={onButtonClick}
          >
            Reports
          </EuiButton>
        }
        isOpen={isPopoverOpen}
        closePopover={closePopover}
      >
        <EuiContextMenu
          initialPanelId={0}
          panels={[
            {
              id: 0,
              title: "Actions",
              items: items,
            },
          ]}
        />
      </EuiPopover>
    </div>
  );
};

export default BauhausAdhoc;
